export enum ERoutesCommon {
  Root = '/',
  TechnicalWork = '/tech-work',
}
export enum ERoutesPublic {
  Login = '/login',
  PasswordForgot = '/password-forgot',
  PasswordRestore = '/password-restore/token',
  SignUpConfirm = '/user/join',
  FranchiseeRegister = '/franchisee/register',
}
export enum ERoutesPrivate {
  Promo = '/promo',
  PromoCreate = '/promo/new',
  Category = '/category',
  CategoryCreate = '/category/new',
  MenuItem = '/menu-item',
  MenuItemCreate = '/menu-item/new',
  Asset = '/asset',
  AssetCreate = '/asset/new',
  Users = '/users',
  UsersInvite = '/users/invite',
  Menu = '/menu',
  Stores = '/stores',
  StoresCreate = '/stores/new',
  Customers = '/customers',
  PasswordAndSecurity = '/password-and-security',
  Statistics = '/statistics',
  Rating = '/feedback',
  QR = '/qr',
  QRCreate = '/qr/new',
  Bitecoin = '/bitecoin',
  BitecoinRewardCategory = '/bitecoin/reward-category',
  BitecoinRewardCategoryCreate = '/bitecoin/reward-category/new',
  BitecoinReward = '/bitecoin/reward',
  BitecoinRewardCreate = '/bitecoin/reward/new',
  Announcements = '/announcements',
  AnnouncementsCreate = '/announcements/new',
  RegionsGroups = '/regions-groups',
}

export enum ERoutesFranchiseePrivate {
  StoreList = '/store-list',
  StorePage = '/store-page',
  Statistics = '/statistics',
  APIKeys = '/api-keys',
  PasswordAndSecurity = '/password-and-security',
  StoreFeedback = '/store-feedback',
  GeneratePO = '/purchase-order/generate-po',
  TrackPO = '/purchase-order/track-po',
  StockReconciliation = '/stock-reconciliation',
}

export const RoutesCirPrefix = '/cir';
